import * as React from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export interface SimpleColumnDef {
    field: string,
    headerName: string,
    width: number | string,
    cellStyle?: string,
    valueFormatter?: ValueFormatterFunction
}

export interface ValueFormatterFunction {
    (data: any): ValueFormatterResult | undefined;
}

export interface ValueFormatterResult {
    component?: any;
}

function InvoiceSimpleTable(props: { columnDefs: SimpleColumnDef[], data: any[], isGrouped?: boolean }) {
    const getHeaderStyle = (width: string | number, cellStyle: any | undefined) => {
        return {
            borderBottom: 'none',
            fontWeight: 600,
            width: `${width}`,
            fontSize: "1rem",
            textAlign: `${cellStyle}`
        };
    };

    const getRowStyle = (width: string | number) => {
        return {
            borderBottom: 'none',
            fontWeight: 400,
            width: `${width}`,
            fontSize: "1rem"
        };
    };

    function resolve(path: string, obj: any) {
        return path.split('.').reduce(function (prev: any, curr: any) {
            return prev ? prev[curr] : null;
        }, obj);
    }

    return (
        <TableContainer>
            <Table sx={{borderCollapse: 'collapse', "& td, & th": {  border: 'none', }}}>
                <TableHead>
                    <TableRow sx={{ borderBottom: 'none', backgroundColor: 'transparent' }}>
                        {props.columnDefs.map((it, index) => {
                            return (
                                <TableCell
                                    key={index}
                                    component={"th"}
                                    sx={getHeaderStyle(it.width, it.cellStyle)}
                                >
                                    {it.headerName}
                                </TableCell>
                            );
                        })}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.isGrouped
                        ? props.data.map((group: any, groupIndex: number) => (
                            <React.Fragment key={groupIndex}>
                                {group.items.length > 1 ? (
                                    <TableRow sx={{ borderBottom: 'none' }}>
                                        <TableCell colSpan={props.columnDefs.length} sx={{ padding: 0 }}>
                                            <Accordion
                                                defaultExpanded={true}
                                                sx={{
                                                    boxShadow: 0.5,
                                                    '&.MuiAccordion-root': {
                                                        borderBottom: 'none',
                                                    },
                                                }}
                                            >
                                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                    <span style={{ fontWeight: 500 }}>{group.groupName}</span>
                                                </AccordionSummary>
                                                <AccordionDetails style={{ padding: 0 }}>
                                                    <Table>
                                                        <TableBody>
                                                            {group.items.map((it: any) => (
                                                                <TableRow key={it.id} sx={{ borderBottom: 'none' }}>
                                                                    {props.columnDefs.map((column, index) => {
                                                                        let value = resolve(column.field, it);
                                                                        return (
                                                                            <TableCell
                                                                                key={index}
                                                                                component={"td"}
                                                                                sx={getRowStyle(column.width)}
                                                                            >
                                                                                {column.valueFormatter
                                                                                    ? column.valueFormatter(it)?.component()
                                                                                    : value}
                                                                            </TableCell>
                                                                        );
                                                                    })}
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </AccordionDetails>
                                            </Accordion>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    group.items.map((it: any) => (
                                        <TableRow key={it.id} sx={{ borderBottom: 'none' }}>
                                            {props.columnDefs.map((column, index) => {
                                                let value = resolve(column.field, it);
                                                return (
                                                    <TableCell
                                                        key={index}
                                                        component={"td"}
                                                        sx={getRowStyle(column.width)}
                                                    >
                                                        {column.valueFormatter
                                                            ? column.valueFormatter(it)?.component()
                                                            : value}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    ))
                                )}
                            </React.Fragment>
                        ))
                        : props.data.map((it: any) => (
                            <TableRow key={it.id}>
                                {props.columnDefs.map((column, index) => {
                                    let value = resolve(column.field, it);
                                    return (
                                        <TableCell
                                            key={index}
                                            component={"td"}
                                            sx={getRowStyle(column.width)}
                                        >
                                            {column.valueFormatter
                                                ? column.valueFormatter(it)?.component()
                                                : value}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default InvoiceSimpleTable;